import { createSlice } from '@reduxjs/toolkit';
import { DynamoConnector } from '../../DynamoConnector';
import { SORT_MAP } from './leaderboardSlice';
import { defaultDetailListQuery, isSwitchingEntity, resetDetailListQuery } from './detailListQuery';
import { setAppRoute } from './appSlice';
import { nextPageCursor } from './listPaging';

export const userDetailsSlice = createSlice({
    name: 'userDetails',
    initialState: {
        profile: {},
        listItems: [],
        nextCursor: null,
        isFetching: false,
        ...defaultDetailListQuery(),
        isRefreshing: false,
    },
    reducers: {
        setIsRefreshing: (state, action) => {
            state.isRefreshing = action.payload;
        },
        setUserDetailsItems: (state, action) => {
            state.listItems = action.payload.map((item) => {
                return {
                    ...item,
                    key: item?.id,
                    storeKey: 'userDetails',
                };
            });
        },
        setUserDetailsNextCursor: (state, action) => {
            state.nextCursor = action.payload;
        },
        addNewUserDetailsItems: (state, action) => {
            const { cursor, isReload } = action.payload;

            state.nextCursor = cursor || null;
            let i = -1;
            const newItems = action.payload.items
                .map((item) => {
                    return {
                        ...item,
                        key: item?.id,
                        storeKey: 'userDetails',
                    };
                })
                .map((item) => {
                    i += 1;

                    return {
                        ...item,
                        key: item?.id,
                        storeKey: 'userDetails',
                        indexPrefix: 'userDetails_',
                        index: i + state?.listItems?.length || 0,
                    };
                });

            if (!isReload) {
                state.listItems = state.listItems.concat(newItems);
            } else {
                state.listItems = newItems;
            }
        },
        setUserDetailsFetching: (state, action) => {
            state.isFetching = action.payload;
        },
        setUserDetailsFilters: (state, action) => {
            state.filters = action.payload;
        },
        setUserDetailsSortBy: (state, action) => {
            state.sortBy = action?.payload || SORT_MAP.POWERLEVEL;
        },
        setUserDetailsSortDirection: (state, action) => {
            state.sortDirection = action?.payload || SORT_MAP.DIRECTION.DESC;
        },
        setUserDetails: (state, action) => {
            state.profile = action.payload;
        },
        setSelectedListIndex: (state, action) => {
            state.selectedListIndex = action.payload;
        },
        resetUserDetailsListQuery: resetDetailListQuery,
    },
});

// Action creators are generated for each case reducer function
export const {
    setIsRefreshing,
    setUserDetailsItems,
    setUserDetails,
    addNewUserDetailsItems,
    setUserDetailsFetching,
    setUserDetailsFilters,
    setUserDetailsSortBy,
    setUserDetailsSortDirection,
    setSelectedListIndex,
    resetUserDetailsListQuery,
} = userDetailsSlice.actions;

export const fetchUserDetails = (id) => (dispatch, getState) => {
    const loaded = getState().userDetails.profile;
    if (isSwitchingEntity([loaded?.id, loaded?.metadata?.profileName], decodeURIComponent(id))) {
        dispatch(resetUserDetailsListQuery());
    }
    dispatch(setUserDetailsFetching(true));
    dispatch(setUserDetails(null));

    DynamoConnector.getUserDetails(id, (results) => {
        if (results) {
            dispatch(setUserDetails(results || null));
            const { filters, sortBy, sortDirection } = getState().userDetails;
            dispatch(fetchUserDetailsItems(null, filters, true, sortBy, sortDirection, results.id));
        } else {
            dispatch(setUserDetailsFetching(false));
            dispatch(setAppRoute({ route: '/' }));
        }
    });
};

export const fetchUserDetailsItems =
    (cursor, filters, isReload = false, sortBy, sortDirection, _id) =>
    (dispatch, getState) => {
        let id = !_id ? null : _id;

        if (!id) {
            if (window.location.pathname.includes(`/id/`)) {
                id = window.location.pathname.substring(window.location.pathname.indexOf(`/id/`) + 4);
            }
        }

        if (id) {
            filters = {
                ...filters,
                id,
            };
        }

        cursor = cursor !== -1 ? cursor : null;

        if (isReload) {
            dispatch(setUserDetailsItems([]));
        }

        dispatch(setUserDetailsFetching(true));

        DynamoConnector.getList(cursor, 'users', sortBy?.index || null, filters, sortDirection, (results) => {
            dispatch(
                addNewUserDetailsItems({
                    items: results?.Items || [],
                    cursor: nextPageCursor(results, getState().userDetails.listItems.length),
                    type: null,
                    isReload,
                })
            );
            dispatch(setUserDetailsFetching(false));
        });
    };

export default userDetailsSlice.reducer;
